import { Translator } from 'Translator';
import InputGroup from 'components/LoginSignUp/InputGroup';
import PasswordInput from 'components/PasswordInput';
import SubmitButton from 'modules/authentication/components/common/SubmitButton';
import React, { ChangeEventHandler, PureComponent } from 'react';

const CSS = require('./LoginForm.module.scss');

interface LoginFormProps {
  handleSubmit: (data: { email: string; password: string }) => void;
  loginButtonLoading: boolean;
}

interface LoginFormState {
  email: string;
  password: string;
}

class LoginForm extends PureComponent<LoginFormProps, LoginFormState> {
  state: LoginFormState = {
    email: '',
    password: '',
  };

  handlePasswordChange: ChangeEventHandler<HTMLInputElement> = (event) => {
    const { value } = event.target;

    this.setState({
      password: value,
    });
  };

  handleEmailChange: ChangeEventHandler<HTMLInputElement> = (event) => {
    const { value } = event.target;

    this.setState({
      email: value,
    });
  };

  handleSubmit = (event: any) => {
    event.preventDefault();
    this.props.handleSubmit(this.state);
  };

  render() {
    return (
      <form className={CSS.form} onSubmit={this.handleSubmit}>
        <InputGroup>
          <label className={CSS.inputLabel}>
            {Translator.translate('Forms.Labels.email', {}, true, 'Email')}
          </label>
          <input
            autoComplete={'email'}
            className={CSS.input}
            type={'email'}
            value={this.state.email}
            name={'email'}
            onChange={this.handleEmailChange}
            data-scrolloffset={60}
            placeholder={'Email'}
          />
        </InputGroup>
        <InputGroup>
          <label className={CSS.inputLabel}>
            {Translator.translate(
              'Forms.Labels.password',
              {},
              true,
              'Password',
            )}
          </label>
          <PasswordInput
            autoComplete={'current-password'}
            value={this.state.password}
            handleChange={this.handlePasswordChange}
            data-scrolloffset={60}
            placeholder={'Password'}
          />
        </InputGroup>
        <SubmitButton
          text={Translator.translate('Forms.Buttons.Login', {}, true, 'Log in')}
          loading={this.props.loginButtonLoading}
        />
      </form>
    );
  }
}

export default LoginForm;
